import Vue from 'vue'
import {createInertiaApp} from '@inertiajs/inertia-vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement, ArcElement, RadialLinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement, ArcElement, RadialLinearScale)

Vue.use(VueAxios, axios)
Vue.use(BootstrapVue);
Vue.use(IconsPlugin)
Vue.use(VueLodash, {lodash})
Vue.mixin({
  methods: {route: window.route},
  computed: {isMobile: () => window.isMobile()},
})

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  setup({el, app, props}) {
    new Vue({
      render: h => h(app, props),
    }).$mount(el)
  },
})
